var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flexed"},[_c('main-menu'),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('main-header'),_vm._v(" "),_c('companies'),_vm._v(" "),_c('videos'),_vm._v(" "),_c('articles'),_vm._v(" "),_c('awards'),_vm._v(" "),_c('books'),_vm._v(" "),_c('social'),_vm._v(" "),_c('footer-cmp')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4caf9ebe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 254
// module chunks = 0